export interface TemplateIdsType {
  POSTER: string
  POSTCARD: string
  STICKER: string
  TENT_5_BY_7: string
}

export interface HttpAgentConfig {
  keepAlive: boolean
  keepAliveMsecs: number
}

export interface Config {
  uri: string // flowcode-api
  uriFlowpage: string
  uriGenerator: string
  flowcodeRoot: string
  subscriptionServiceUri: string
  optimizelyAPIKey: string
  templateIds: TemplateIdsType
  http: HttpAgentConfig
}

export interface ConfigEnvironments {
  development: Config
  staging: Config
  production: Config
  preprod: Config
}

export type AppEnvironmentType = 'development' | 'production' | 'staging'

export interface SocialMediaIconProps {
  width?: number | string
  height?: number | string
  id?: string
  color?: string
}

export interface GqlErrorObjectType {
  response: {
    errors: [
      {
        message: string
        extensions: {
          code: string
          reason: string
        }
      }
    ]
  }
  stack: string
}

export enum MaskType {
  CIRCLE = 'circle',
  SQUARE = 'square',
  RECTANGLE = 'rectangle',
  IPHONEX = 'iphonex',
  FEATURED = 'featured',
  NO_IMAGE = 'noImage'
}
